export const calculateMortgage = (principal, annualRate, termYears) => {
  // Convert annual rate to monthly rate (percentage to decimal)
  const monthlyRate = (annualRate / 100) / 12;
  
  // Total number of payments
  const totalPayments = termYears * 12;
  
  // Calculate monthly payment using the formula:
  // M = P * [r(1+r)^n] / [(1+r)^n - 1]
  const monthlyPayment = principal * 
    (monthlyRate * Math.pow(1 + monthlyRate, totalPayments)) / 
    (Math.pow(1 + monthlyRate, totalPayments) - 1);
  
  // Calculate total amount paid and total interest
  const totalAmountPaid = monthlyPayment * totalPayments;
  const totalInterest = totalAmountPaid - principal;
  
  // Calculate first payment breakdown
  const firstPaymentInterest = principal * monthlyRate;
  const firstPaymentPrincipal = monthlyPayment - firstPaymentInterest;
  
  return {
    monthlyPayment: Math.round(monthlyPayment * 100) / 100,
    totalInterest: Math.round(totalInterest * 100) / 100,
    totalAmountPaid: Math.round(totalAmountPaid * 100) / 100,
    firstPaymentInterest: Math.round(firstPaymentInterest * 100) / 100,
    firstPaymentPrincipal: Math.round(firstPaymentPrincipal * 100) / 100
  };
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatPercentage = (rate) => {
  return `${rate.toFixed(2)}%`;
};